export enum Status {
  draft = 'draft',
  review = 'in review',
  published = 'published',
  archived = 'archived'
}
